import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const TooltipContainer = styled.div `
  display: flex;
  flex-direction: column;
  background-color: ${theme.semantic.surface.primary};
  box-shadow: ${theme.dropShadow[200]};
  color: ${theme.semantic.text[300]};
  padding: ${theme.spacing.md} ${theme.spacing.xl};
`;
export const Rect = styled.rect `
  &:hover {
    opacity: 0.8;
  }

  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
`;
